VerificationController.$inject = [
	"Authentication.VerificationServices",
	"$scope",
	"$stateParams",
	"$state"
];

function VerificationController(
	VerificationServices,
	$scope,
	stateParams,
	state
) {
	var self = this;
	let id = stateParams.id;

	self.verify = async function () {
		let parameter = {
			type: "Accounts",
			id: id,
			routeParams: "VerificationCode",
			routeParams2: "verify"
		};

		await VerificationServices.create(parameter, { userId: id }).$promise.then(
			response => {
				self.phone = response.phone;
			},
			errResponse => {
			}
		);
	};

	self.resend = async function () {
		let parameter = {
			type: "Accounts",
			id: id,
			routeParams: "VerificationCode",
			routeParams2: "resend"
		};

		await VerificationServices.create(parameter, { userId: id }).$promise.then(
			response => {
				iziToast.show({
					message: "کد تایید مجددا ارسال شد.",
					theme: 'light',
					color: 'green',
				});
			},
			errResponse => {
				iziToast.show({
					message: errResponse.data.message,
					theme: "light",
					color: "red"
				});
			},
		);
	};

	self.verification = function () {
		$scope.otpInput.onDone();
	};

	$scope.otpInput = {
		size: 6,
		type: "text",
		onDone: function (value) {
			let parameter = {
				type: "Accounts",
				id: id,
				routeParams: "VerificationCode",
				routeParams2: "verify"
			};
			VerificationServices.create(parameter, {
				code: value,
				userId: id
			}).$promise.then(
				response => {
					iziToast.show({
						message: "حساب کاربری شما فعال گردید. اکنون می توانید وارد سیستم شوید.",
						theme: 'light',
						color: 'green',
					});
					state.go("Authentication.Login");
				},
				errResponse => {
					iziToast.show({
						message: errResponse.data.message,
						theme: "light",
						color: "red"
					});
				}
			);
		}
	};
}

module.exports = ngModule => {
	ngModule.controller(
		"Authentication.VerificationController",
		VerificationController
	);
};
